import { ToggleGroup, ToggleGroupItem } from '@repo/videa-components/src/index';
import classNames from 'classnames';

// Main filter types for the toggle group
export type ImageFilterType = 'BW' | 'PA' | 'PHOTOS';

type ImageCounts = {
  BW: number;
  PA: number;
  PHOTOS: number;
};

type ImageFilterToggleProps = {
  imageFilter: ImageFilterType[];
  imageCounts: ImageCounts;
  onFilterChange: (filters: string[]) => void;
};

export const ImageFilterToggle = ({
  imageFilter,
  imageCounts,
  onFilterChange,
}: ImageFilterToggleProps) => {
  return (
    <div className="vai-bg-zinc-800 vai-p-1.5 vai-rounded-md vai-w-fit">
      <div className="vai-flex vai-gap-2 vai-justify-center">
        <ToggleGroup
          type="multiple"
          value={imageFilter}
          onValueChange={onFilterChange}
          className="vai-gap-2"
        >
          {(['BW', 'PA', 'PHOTOS'] as ImageFilterType[]).map((filter) => (
            <ToggleGroupItem
              key={filter}
              value={filter}
              className="vai-font-inter vai-font-bold vai-text-sm vai-rounded-md vai-px-4 vai-py-2 vai-whitespace-nowrap focus:vai-outline-none vai-transition-colors vai-duration-200 vai-flex vai-items-center vai-gap-2 data-[state=on]:vai-bg-zinc-950 data-[state=on]:vai-text-white vai-text-zinc-200 hover:vai-bg-zinc-600"
            >
              <span>{filter}</span>
              <div
                className={classNames(
                  'vai-w-6 vai-h-6 vai-rounded-full vai-flex vai-items-center vai-justify-center vai-text-xs vai-font-medium vai-transition-colors vai-duration-200',
                  {
                    'vai-bg-slate-800 vai-text-white':
                      imageFilter.includes(filter),
                    'vai-bg-zinc-950 vai-text-zinc-300':
                      !imageFilter.includes(filter),
                  },
                )}
              >
                {imageCounts[filter]}
              </div>
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
    </div>
  );
};
